export default {"src":"/_next/static/media/zoom.7018455e.svg","height":42,"width":35,"blurWidth":0,"blurHeight":0};